exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body[data-v-6a2fd220] {\n  padding: 24px 10px 10px;\n}\n.modal-container[data-v-6a2fd220] {\n  max-width: 370px;\n}\n", ""]);

// exports
